export default "__VITE_ASSET__DJLXWxMT__"